import { RouteComponentProps } from "@reach/router";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import useSWR from "swr";
import BigSlides from "../Components/BigSlides";
// import Button from "../Components/Button";
// import EventPlansSection from "../Components/EventPlans";
// import EventRundown from "../Components/EventRundown";
// import EventSponsors from "../Components/EventSponsors";
import Layout from "../Components/Layout";
// import Testimonials from "../Components/Testimonials";
import { useSelector } from "react-redux";
import WhatsAbout from "../Components/WhatsAbout";
import { useWithLang } from "../i18n";
// import Printicon from "../icons/PrintIcon";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { Sponsor } from "../Components/EventSponsors";
import { RootState } from "../stores";
import Api, {
  ApiResponse,
  getBaseURL,
  parseErrorValidation,
} from "../utils/api";
import { SettingProp } from "../utils/types";

// import InfoLomba from "../Components/InfoLomba";
// import Expo from "../Components/Expo";
// import BigSlidesIBD from "../Components/IDB/BigSlidesIBD";
// import Dokumentasi from "../Components/IDB/Dokumentasi";
// import Figures from "../Components/IDB/Figures";
// import InfoIBD from "../Components/IDB/InfoIBD";
// import Video from "../Components/IDB/Video";

interface Props extends RouteComponentProps {}

const IndexPage = (props: Props) => {
  const sliderRef = useRef();
  const { t } = useTranslation();
  const { f } = useWithLang();
  const { isLogin } = useSelector((state: RootState) => state.user);
  const url_register = isLogin ? "/register-event" : "https://s.id/form-ibd";

  const { data: bookSeat } = useSWR<ApiResponse<SettingProp>>(
    f("/public/pages/book-seat"),
    {
      initialData: null,
    }
  );

  const { data: done } = useSWR<ApiResponse<Sponsor[]>>(
    f("/public/sponsors/done"),
    {
      initialData: null,
    }
  );

  const { data: sponsor } = useSWR<ApiResponse<Sponsor[]>>(
    f("/public/sponsors"),
    {
      initialData: null,
    }
  );

  const categoryOrder = ["platinum", "gold", "bronze", "silver", "in-kind"];

  const groupedSponsors = sponsor?.data?.reduce((acc, item) => {
    if (!acc[item.category]) acc[item.category] = [];
    acc[item.category].push(item);
    return acc;
  }, {});

  const sponsorsInputInitialValues = {
    fullname: "",
    email: "",
    phone: "",
    company_name: "",
    sponsor_type: "",
  };

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const sponsorsInputValidation = Yup.object().shape({
    fullname: Yup.string().required("Full Name is a required field").min(3),
    email: Yup.string()
      .email("Format email not valid")
      .required("Email is a required field")
      .min(3),
    phone: Yup.string().matches(phoneRegExp, "Phone Number is not valid"),
    company_name: Yup.string()
      .required("Company Name is a required field")
      .min(3),
    sponsor_type: Yup.string().required("Sponsor Type is a required field"),
  });

  const onSubmitInputSponsor = async (values: any, { setErrors }) => {
    console.log(values);

    try {
      await Api.post("/public/sponsorship", values);
      toast.success(t("Your Request Send sucessfully!"));
    } catch (e) {
      if (e.response?.data?.errors) {
        setErrors(parseErrorValidation(e.response?.data?.errors));
      } else {
        toast.error(
          e.response?.data?.message || "Something went wrong!, please try again"
        );
      }
    }
  };

  const totalItems = done?.data?.length || 0;
  const remainder = totalItems % 5;
  const fillers = remainder > 0 ? 5 - remainder : 0;
  const startFillers = Math.floor(fillers / 2);
  const endFillers = fillers - startFillers;

  return (
    <Layout transparent lightAfter={sliderRef}>
      {/* SLIDER */}
      <section className="mb-8">
        <BigSlides compRef={sliderRef} />
      </section>
      {/* SLIDER */}

      {/* KEPESERTAAN */}
      <section className="my-10 md:my-20 container mx-auto">
        <div className="flex items-center justify-center">
          <h2 className="text-3xl font-semibold font-sans">
            {t("Statistik Kehadiran Peserta")}
          </h2>
        </div>
        <div className="grid grid-cols-1 gap-3 text-white mt-10">
          {/* <div className="px-4 py-4 bg-gradient-to-br from-gradientBlue1 to-gradientBlue4 rounded-lg">
            <div className="flex flex-col items-center justify-center text-center gap-5">
              <span className="text-md md:text-2xl">PENDAFTAR PESERTA</span>
              <span className="text-md md:text-2xl">1.103 PESERTA</span>
            </div>
          </div> */}
          {/* <div className="px-4 py-4 bg-gradient-to-br from-gradientBlue1 to-gradientBlue4 rounded-lg">
            <div className="flex flex-col items-center justify-center text-center gap-5">
              <span className="text-md md:text-2xl">PESERTA DAY 1</span>
              <span className="text-md md:text-2xl">602 PESERTA</span>
            </div>
          </div>
          <div className="px-4 py-4 bg-gradient-to-br from-gradientBlue1 to-gradientBlue4 rounded-lg">
            <div className="flex flex-col items-center justify-center text-center gap-5">
              <span className="text-md md:text-2xl">PESERTA DAY 2</span>
              <span className="text-md md:text-2xl">176 PESERTA</span>
            </div>
          </div> */}
          <div className="col-span-3 w-full px-4 py-4 bg-gradient-to-br from-gradientBlue1 to-gradientBlue4 rounded-lg">
            <div className="flex flex-col items-center justify-center text-center">
              <span className="text-md md:text-2xl">
                TOTAL PESERTA : 778 PESERTA
              </span>
            </div>
          </div>
        </div>
      </section>
      {/* KEPESERTAAN */}

      {/* RECAP */}
      <section className="my-10 md:my-20 container mx-auto">
        <div className="flex flex-col md:flex-row gap-5">
          <div className="md:w-6/12 md:pr-4 mb-8 md:mb-0 flex items-center justify-center">
            <img src="/images/recap.jpg" alt="Recap 2025" />
          </div>
          <div className="md:w-6/12 md:pr-4 mb-8 md:mb-0">
            <div className="flex items-center">
              <h2 className="text-3xl font-semibold font-sans">
                {t("RECAP INDONESIA DIGITAL FORUM 2025")}
              </h2>
            </div>
            <div className="mt-5">
              <span>
                Inilah cuplikan dari rangkaian kegiatan Indonesia Digital Forum
                2025 yang mengusung tema “Kolaborasi dan Sinergi Membangun
                Ekosistem Digital Indonesia.” Acara ini mempertemukan berbagai
                pemangku kepentingan pemerintah, industri, akademisi, dan
                komunitas digital untuk bersama-sama memperkuat transformasi
                digital nasional. Melalui diskusi dan kolaborasi, forum ini
                bertujuan menciptakan ekosistem digital yang inklusif, aman, dan
                berkelanjutan bagi seluruh masyarakat Indonesia.
              </span>
            </div>
            <div className="grid grid-cols-1 place-items-center md:grid-cols-2 gap-3 mt-5">
              {/* <a href="">
                <button className="uppercase text-md px-4 py-2 bg-black text-white rounded-md">
                  Read the recap{" "}
                </button>
              </a> */}
              <a
                href="https://www.flickr.com/photos/202978356@N08/"
                target="_blank"
              >
                <button className="uppercase text-md px-4 py-2 bg-black text-white rounded-md w-80 md:w-56">
                  LIHAT FOTO ACARA{" "}
                </button>
              </a>
              <a
                href="https://www.youtube.com/channel/UCuKBQo5lpWScSec9ZqkqHNQ"
                target="_blank"
              >
                <button className="uppercase text-md px-4 py-2 bg-black text-white rounded-md w-80 md:w-56">
                  LIHAT SESI{" "}
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* RECAP */}

      {/* ABOUT */}
      <section className="my-10 md:my-20 container mx-auto">
        <WhatsAbout />
      </section>
      {/* ABOUT */}

      {/* YANG HADIR */}
      <section className="mb-10 text-white rounded-xl max-w-6xl flex justify-center mx-auto bg-gradient-to-b from-gradientBlue1 to-gradientBlue2 md:bg-none">
        <div className="container mx-auto">
          <img
            src="/images/hadir.jpg"
            alt="Hadir"
            className="w-full hidden md:block"
          />

          <div className="block md:hidden p-4">
            <div className="flex items-center">
              <h2 className="text-3xl font-semibold font-sans">
                {t("Siapa saja yang akan hadir ?")}
              </h2>
            </div>
            <div className="content mt-3 font-sans text-lg text-justify">
              <p className="mb-4">
                Forum ini terbuka untuk seluruh pemangku kepentingan yang
                berperan dalam pengembangan ekosistem digital Indonesia, di
                antaranya:
              </p>
              <ol>
                <li>
                  1. Pejabat pemerintah dan regulator di bidang komunikasi,
                  teknologi, dan transformasi digital
                </li>
                <li>
                  2. Pelaku industri digital, penyelenggara internet, dan
                  perusahaan teknologi
                </li>
                <li>
                  3. Akademisi, peneliti, dan pakar di bidang teknologi
                  informasi dan kebijakan digital
                </li>
                <li>
                  4. Komunitas digital, pegiat teknologi, dan startup digital
                </li>
                <li>5. Asosiasi dan organisasi profesi di sektor TIK</li>
                <li>6. Media teknologi dan jurnalis kebijakan digital</li>
                <li>
                  7. Generasi muda digital savvy yang ingin berkontribusi dalam
                  transformasi digital nasional
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      {/* YANG HADIR */}

      {/* VISI MISI */}
      <section className="py-10 mb-10">
        <div className="container mx-auto">
          <div className="flex flex-col md:flex-row mb-8">
            <div className="md:w-6/12 md:pr-4 mb-8 md:mb-0 ml-3">
              <img src="/images/visi.jpg" alt="Tentang" className="w-full" />
            </div>
            <div className="md:w-6/12 md:pr-4 mb-8 md:mb-0 ml-3 flex flex-col justify-center gap-3">
              <div className="flex items-center">
                <h2 className="text-3xl font-semibold font-sans">
                  {t("VISI")}
                </h2>
              </div>
              <div className="content mt-3 font-sans text-lg text-justify">
                Terciptanya Kolaborasi dan Sinergi Ekosistem Digital Menuju
                Indonesia Emas 2045.
              </div>
              <div className="flex items-center">
                <h2 className="text-3xl font-semibold font-sans">
                  {t("MISI")}
                </h2>
              </div>
              <div className="content mt-3 font-sans text-lg text-justify">
                <ol type="1">
                  <li>
                    1. Menyediakan wadah komunikasi dan diskusi para pelaku
                    industri digital di tingkat nasional.
                  </li>
                  <li>
                    2. Membahas isu - isu pembangunan ekosistem digital dalam
                    rangka menyusun strategi digital nasional.
                  </li>
                  <li>
                    3. Menghasilkan suatu kerangka rekomendasi dan prioritas
                    nasional untuk mendorong kolaborasi dan sinergi para pelaku
                    industri digital nasional.
                  </li>
                  <li>
                    4. Memperkuat komitmen bersama dalam hal kolaborasi dan
                    sinergi ekosistem digital nasional.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* VISI MISI */}

      {/* EVENT SPEAKER */}
      {/* <section className="pb-10">
        <EventSpeakers />
      </section> */}
      {/* EVENT SPEAKER */}

      {/* GARIS HITAM */}
      {/* <div className="flex flex-col md:flex-row h-1 bg-black container mx-auto"></div> */}
      {/* GARIS HITAM */}

      {/* PENYELENGARA */}
      <section className="py-10 mb-10 mt-5">
        <div className="container mx-auto px-4">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-4xl font-semibold font-sans">
              {t("HOSTED BY")}
            </h2>
            <div className="flex justify-center items-center mt-4 gap-4 md:gap-16 md:flex-row ">
              <a href="https://pandi.id/" target="_blank">
                <img
                  src="/images/logo-pandi-color.png"
                  alt="Express Freedom"
                  className="h-10 md:h-16 mb-3"
                />
              </a>
              <a href="https://apjii.or.id/" target="_blank">
                <img
                  src="/images/apji.png"
                  alt={t("Home")}
                  className="ml-3 h-10 md:h-24 bg-transparent"
                />
              </a>
              <a href="https://www.atsi.or.id/" target="_blank">
                <img
                  src="/images/atsi.png"
                  alt={t("Home")}
                  className="ml-3 h-10 md:h-24 bg-transparent"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* PENYELENGARA */}

      {/* SPONSOR */}
      <section className="relative bg-gradient-to-r from-gradientBlue1 to-gradientBlue2 overflow-hidden text-white">
        <h1 className="text-center my-4 text-4xl font-semibold text-slate-50">
          {" "}
          Meet up our Sponsors{" "}
        </h1>
        {groupedSponsors &&
          categoryOrder
            .filter((category) => groupedSponsors[category]) // cuma render yang ada datanya
            .map((category, idx) => {
              const items = groupedSponsors[category];
              const imageSize = {
                platinum: "w-56",
                gold: "w-44",
                // silver: "w-36",
                // bronze: "w-28",
                "in-kind": "w-20",
              };
              const colSpan = {
                platinum: "col-span-2 xl:col-span-2",
                gold: "col-span-2 xl:col-span-1",
                // silver: "col-span-1",
                // bronze: "col-span-1",
                "in-kind": "col-span-1",
              };

              return (
                <div
                  key={idx}
                  className="flex flex-col mx-auto items-center justify-center max-w-5xl my-4"
                >
                  <h1 className="text-center my-4 text-4xl font-semibold text-slate-50 capitalize">
                    {category === "in-kind" ? "" : category}
                  </h1>
                  <div className="flex flex-wrap justify-center gap-8 px-4">
                    {items.map((item, index) => (
                      <div
                        key={index}
                        className={`flex items-center justify-center bg-white rounded-lg p-4 ${colSpan[category]}`}
                      >
                        <a href={item.url} className="" target="_blank">
                          <img
                            src={getBaseURL(item.image)}
                            className={`${imageSize[category]} object-contain`}
                            alt={item.name}
                          />
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
      </section>
      {/* SPONSOR */}

      {/* PREVIOUSE SPONSOR */}
      {/* <section className="py-10 mb-10 mt-5 bg-gradient-to-b from-gradientBlue1 to-gradientBlue2 text-white rounded-xl max-w-6xl flex justify-center mx-auto">
        <div className="container mx-auto px-4">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-6xl font-semibold font-sans">
              {t("Last Event Sponsors")}
            </h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-5 gap-16 md:gap-8 max-w-2xl mx-16 md:mx-auto">
            {done?.data?.map((item, index) => (
              <div
                key={index}
                className="flex items-center justify-center bg-white rounded-lg p-4 w-32 h-[100px]" // bisa diatur sesuai kebutuhan
              >
                <img
                  src={getBaseURL(item.image)}
                  alt={item.name}
                  className="max-w-full max-h-full object-contain text-black"
                />
              </div>
            ))}
          </div>
        </div>
      </section> */}
      {/* PREVIOUSE SPONSOR */}

      {/* FORM SPONSOR */}
      {/* <section className="py-10 mb-10 mt-5">
        <div className="flex flex-col md:flex-row items-start container  mx-auto gap-2 md:gap-8">
          <div className="w-full md:w-1/2 flex flex-col justify-start ">
            <h2 className="text-2xl md:text-4xl mb-4">
              {t(
                "Tunjukkan dukunganmu pada masa depan ekosistem digital Indonesia"
              )}
            </h2>
            <h2 className="text-2xl md:text-4xl mb-4">
              {t("Dengan menjadi sponsor, di Indonesia Digital Forum 2025")}
            </h2>
            <div className="bg-gray-100 p-4 rounded-md">
              <p>{t("This is where you can put notes, image uploads, etc.")}</p>
            </div>
          </div>

          <div className="w-full md:w-1/2 bg-gradient-to-br from-gradientBlue3 to-gradientBlue4 mx-auto p-4 rounded-md">
            <Formik
              initialValues={sponsorsInputInitialValues}
              onSubmit={onSubmitInputSponsor}
              validationSchema={sponsorsInputValidation}
            >
              {({ isSubmitting, values, handleChange }) => (
                <Form>
                  <FormLoading isLoading={isSubmitting}>
                    <div className="flex flex-wrap -mx-4">
                      <div className="flex flex-row">
                        <div className="p-4 w-full">
                          <label className="block mb-2 md:font-bold text-md md:text-xl text-white">
                            {t("Full Name")}
                          </label>
                          <InputField
                            className="form-input w-full"
                            name="fullname"
                            type="text"
                            placeholder={t("Full Name")}
                          />
                          <div className="text-red-700">
                            <ErrorMessage name="fullname" />
                          </div>
                        </div>

                        <div className="p-4 w-full">
                          <label className="block mb-2 md:font-bold text-md md:text-xl text-white">
                            {t("Email")}
                          </label>
                          <InputField
                            className="form-input w-full"
                            name="email"
                            placeholder={t("Email")}
                          />
                          <div className="text-red-700">
                            <ErrorMessage name="email" />
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-row">
                        <div className="p-4 w-full">
                          <label className="block mb-2 md:font-bold text-md md:text-xl text-white">
                            {t("Company Name")}
                          </label>
                          <InputField
                            className="form-input w-full"
                            name="company_name"
                            placeholder={t("Company Name")}
                          />
                          <div className="text-red-700">
                            <ErrorMessage name="company_name" />
                          </div>
                        </div>

                        <div className="p-4 w-full">
                          <label className="block mb-2 md:font-bold text-md md:text-xl text-white">
                            {t("Phone Number")}
                          </label>
                          <InputField
                            className="form-input w-full"
                            name="phone"
                            type="text"
                            placeholder={t("Phone Number")}
                          />
                          <div className="text-red-700">
                            <ErrorMessage name="phone" className="" />
                          </div>
                        </div>
                      </div>

                      <div className="p-4 w-full">
                        <label className="block mb-2 md:font-bold text-white">
                          {t("Sponsor Type")}
                        </label>
                        <Field
                          as="select"
                          className="form-input w-full px-3 py-2 rounded-md border-gray-300"
                          name="sponsor_type"
                          value={values.sponsor_type}
                          onChange={handleChange}
                        >
                          <option label={t("Select Type")}>""</option>
                          <option value="1" label="Platinum">
                            Platinum
                          </option>
                          <option value="2" label="Gold">
                            Gold
                          </option>
                          <option value="3" label="Silver">
                            Silver
                          </option>
                          <option value="4" label="Bronze">
                            Bronze
                          </option>
                        </Field>
                        <div className="text-red-700">
                          <ErrorMessage name="sponsor_type" />
                        </div>
                      </div>

                      <h3 className="p-4 w-full text-white">
                        {t(
                          "Enter as many details as possible about your vision and will make it happen!"
                        )}
                      </h3>

                      <div className="p-4 w-full flex justify-end gap-2">
                        <Button
                          type="submit"
                          color="primary"
                          className="font-bold"
                        >
                          {t("Save Changes")}
                        </Button>
                      </div>
                    </div>
                  </FormLoading>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </section> */}
      {/* FORM SPONSOR */}

      {/* SPONSORING ASSOCIATION */}
      <section className="py-10 mb-10">
        <div className="container mx-auto px-4">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-semibold font-sans">
              {t("SUPPORTING ASSOCIATION")}
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-10 place-items-center">
              <a href="https://www.asioti.id/" target="_blank">
                <img
                  src="/images/asosiasi/1.png"
                  alt="Asosiasi"
                  className="w-28 md:w-40 mb-3"
                />
              </a>
              <a href="https://mastel.id/" target="_blank">
                <img
                  src="/images/asosiasi/2.png"
                  alt="Asosiasi"
                  className="w-32 md:w-48 mb-3"
                />
              </a>
              <a href="#" target="_blank">
                <img
                  src="/images/asosiasi/3.png"
                  alt="Asosiasi"
                  className="w-36 md:w-48 mb-3"
                />
              </a>
              <a href="#" target="_blank">
                <img
                  src="/images/asosiasi/8.png"
                  alt="Asosiasi"
                  className="w-48 md:w-full mb-3"
                />
              </a>
              {/* <div className="md:col-span-4 flex justify-center gap-8 max-w-3xl"> */}
              <a href="https://korika.id/" target="_blank">
                <img
                  src="/images/asosiasi/5.png"
                  alt="Asosiasi"
                  className="w-28 md:w-44 mb-3"
                />
              </a>
              <a href="https://peratin.or.id/" target="_blank">
                <img
                  src="/images/asosiasi/6.png"
                  alt="Asosiasi"
                  className="w-28 md:w-44 mb-3"
                />
              </a>
              <a href="#" target="_blank">
                <img
                  src="/images/asosiasi/4.png"
                  alt="Asosiasi"
                  className="w-36 md:w-52 mb-3"
                />
              </a>
              <a href="https://www.askalsi.or.id/" target="_blank">
                <img
                  src="/images/asosiasi/7.png"
                  alt="Asosiasi"
                  className="w-52 md:w-full mb-3"
                />
              </a>
              <a href="https://www.apjatel.id/" target="_blank">
                <img
                  src="/images/asosiasi/9.png"
                  alt="Asosiasi"
                  className="w-28 md:w-40 mb-3"
                />
              </a>
              <a href="https://www.cert.or.id/" target="_blank">
                <img
                  src="/images/asosiasi/10.jpg"
                  alt="Asosiasi"
                  className="w-28 md:w-40 mb-3"
                />
              </a>
              <a href="https://blockchainsociety.id/" target="_blank">
                <img
                  src="/images/asosiasi/11.png"
                  alt="Asosiasi"
                  className="w-48 md:w-52 mb-3"
                />
              </a>
            </div>
            {/* </div> */}
          </div>
        </div>
      </section>
      {/* SPONSORING ASSOCIATION */}

      {/* MEDIA PATNER */}
      <section className="py-10 mb-10 mt-5 bg-gradient-to-br from-gradientBlue3 to-gradientBlue4 mx-auto p-4 rounded-md">
        <div className="container mx-auto px-4">
          <div className="text-center text-white mb-8">
            <h2 className="text-2xl font-semibold font-sans">
              {t("MEDIA PARTNER")}
            </h2>
            <div className="flex justify-center items-center gap-5 md:gap-16 mt-10 bg-white mx-auto p-4 rounded-lg max-w-xl">
              <a href="https://www.cnnindonesia.com/" target="_blank">
                <img
                  src="/images/cnn.png"
                  alt="Express Freedom"
                  className="w-16 md:w-20"
                />
              </a>
              <a href="https://amsi.or.id/" target="_blank">
                <img
                  src="/images/amsi.png"
                  alt="Express Freedom"
                  className="w-24 md:w-36"
                />
              </a>
              <a href="https://olenka.id/" target="_blank">
                <img
                  src="/images/olenka.png"
                  alt="Express Freedom"
                  className="w-24 md:w-32"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* MEDIA PATNER */}

      {/* <section className="my-5 md:my-10 container mx-auto">
        <Video />
      </section> */}
      {/* <section className="my-5 md:my-10 container mx-auto">
        <InfoLomba />
        <InfoIBD />
      </section> */}
      {/* <section className="my-5 md:my-10 container mx-auto">
        <Expo />
      </section> */}
      {/* <section>
        <Figures />
      </section> */}
      {/* <div className="bg-gray-200 pt-4 -mt-10">
        <section className="pb-10">
          <EventSpeakers />
        </section>
        <section className="my-10 container mx-auto hidden">
          <div className="flex items-center flex-col md:flex-row">
            <div className="flex-1 flex w-full md:w-auto items-center mb-6 md:mb-0">
              <div className="mr-3">
                <img
                  src="/images/pandi.png"
                  className="w-14 md:w-auto"
                  alt="pandi id logo"
                />
              </div>

              <h2 className="text-xl md:text-3xl font-semibold font-sans">
                {t("RUNDOWN EVENT")}
              </h2>
            </div>
            <div className="w-full md:w-auto flex justify-end">
              <Button
                size="md"
                className="flex items-center font-sans md:text-xl font-semibold bg-white"
                color="secondary"
                onClick={() => {
                  window.open(
                    process.env.REACT_APP_BASE_URL + "/public/events/download",
                    "_blank"
                  );
                }}
                outline>
                <Printicon className="mr-2 w-6 h-6" />
                {t("Download Schedule")}
              </Button>
            </div>
          </div>
        </section>
        <div className="container mx-auto mb-8">
          {isLogin && (
            <Link to="/register-event">
              <Button color="primary" className="font-sans">
                {t("REGISTER EVENT")}
              </Button>
            </Link>
          )}
        </div>

        <section className="mb-8 container mx-auto">
          <EventRundown />
        </section>

        <section className="hidden">
          <EventPlansSection />
        </section>

        <section className="">
          <EventSponsors />
        </section>

        <section className="hidden">
          <Testimonials />
        </section>

        <section className="border border-t">
          <Dokumentasi />
        </section>

        <section className="mx-auto hidden">
          <div
            className="flex flex-col items-center py-16 px-8 text-center text-white"
            style={{
              background: "#1A1438",
            }}>
            <h1 className="text-3xl font-bold">{t("BOOK YOUR SEAT")}</h1>
            <p className="mt-4" style={{ maxWidth: 600 }}>
              {bookSeat?.data?.value}
            </p>
            <div className="mt-4">
              {isLogin ? (
                <Link to={url_register}>
                  {" "}
                  <Button
                    className="mx-2 mb-4 md:text-2xl font-sans"
                    color="primary">
                    {t("REGISTER")}
                  </Button>
                </Link>
              ) : (
                <a href={url_register}>
                  <Button
                    className="mx-2 mb-4 md:text-2xl font-sans"
                    color="primary">
                    {t("REGISTER")}
                  </Button>
                </a>
              )}
            </div>
          </div>
        </section>
      </div> */}
    </Layout>
  );
};

export default IndexPage;
